import type { RegisterOptions } from "react-hook-form";

interface GetValidationRulesParams {
  required?: boolean;
  rules?: RegisterOptions;
  t?: (key: string) => string;
}

export const getValidationRules = ({
  required = true,
  rules = {},
  t,
}: GetValidationRulesParams): RegisterOptions => {
  return {
    ...(required
      ? {
          required: t
            ? t("forms.validation.required")
            : "This field is required",
        }
      : {}),
    ...rules,
  };
};
